{
  "verse": {
    "loading": "Memuat ayat...",
    "error": "Tidak dapat memuat ayat",
    "reference": "— Surah {{surah}}, Ayat {{ayah}}",
    "arabicUnavailable": "(Teks Arab tidak tersedia)",
    "english": "Inggris",
    "arabic": "العربية",
    "swapLanguage_aria": "Tukar bahasa",
    "toggleLanguage_title": "Alihkan Inggris / Arab",
    "reflect": "Renungkan",
    "reflecting": "Memikirkan…",
    "reflect_aria": "Buat refleksi pribadi yang menghubungkan ayat ini dengan niat Anda",
    "insights": "Wawasan",
    "insights_aria": "Buka Wawasan Quran AI",
    "share": "Bagikan",
    "share_aria": "Bagikan ayat ini sebagai gambar",
    "share_title": "Bagikan ayat ini",
    "removeFromFavorites_aria": "Hapus dari favorit",
    "saveToFavorites_aria": "Simpan ke favorit",
    "favoritesProLocked_aria": "Favorit adalah fitur Pro",
    "favoritesUpgrade_aria": "Tingkatkan untuk menyimpan favorit",
    "signInToSave": "Masuk untuk menyimpan favorit.",
    "failedToUpdateFavorites": "Gagal memperbarui favorit",
    "couldNotReflect": "Tidak dapat membuat refleksi",
    "shareCaption": "\"{{text}}\"\n— Surah {{surah}}, Ayat {{ayah}}\n\nrhemn.com",
    "imageSavedVerseCopied": "Gambar tersimpan · ayat disalin",
    "imageSaved": "Gambar ayat tersimpan",
    "couldNotCreateImage": "Tidak dapat membuat gambar"
  },
  "insights": {
    "panel_aria": "Panel Wawasan Quran",
    "title": "Wawasan",
    "reference": "Surah {{surah}}, Ayat {{ayah}}",
    "close_aria": "Tutup panel Wawasan",
    "versePreview_aria": "Pratinjau ayat",
    "back_aria": "Kembali",
    "tryAgain": "Coba lagi",
    "backTo_aria": "Kembali ke {{ref}}",
    "copyVerse_aria": "Salin {{ref}}",
    "openingVerse": "Membuka ayat…",
    "verseError": "Tidak dapat membuka ayat."
  },
  "proGate": {
    "title": "Wawasan Quran AI adalah fitur Pro",
    "subtitleSafari": "Buka pemahaman mendalam dan kontekstual setiap ayat dengan Rhemn Pro. Sudah menjadi anggota? Terbuka otomatis saat Anda masuk.",
    "subtitle": "Buka pemahaman mendalam dan kontekstual untuk setiap ayat.",
    "bulletAsk": "Tanyakan apa saja tentang ayat ini",
    "bulletTafsir": "Ringkasan tafsir bertenaga AI secara instan",
    "bulletRelated": "Temukan ayat-ayat yang terkait secara tematis",
    "upgrade": "Tingkatkan ke Pro"
  },
  "ask": {
    "heading": "Tanya",
    "suggestion1": "Apa konteks yang lebih luas dari ayat ini?",
    "suggestion2": "Bagaimana saya bisa menerapkannya dalam kehidupan sehari-hari?",
    "suggestion3": "Apa kata para ulama klasik tentang ini?",
    "placeholder": "Tanyakan apa saja tentang ayat ini…",
    "input_aria": "Ajukan pertanyaan tentang ayat ini",
    "submit_aria": "Kirim pertanyaan",
    "submit_title": "Kirim (⌘↵)",
    "submit_label": "Tanya",
    "submit_hint": "⌘↵",
    "suggestions_aria": "Pertanyaan yang disarankan",
    "error": "Tidak bisa mendapatkan jawaban.",
    "pending": "Merenungkan pertanyaan Anda…",
    "attribution": "Jawaban dibuat AI · Bukan pengganti keilmuan yang berkualitas"
  },
  "tafsir": {
    "heading": "Tafsir",
    "emptyText": "Dapatkan ringkasan tafsir yang dibuat AI untuk ayat ini.",
    "generate": "Buat Tafsir",
    "commentary": "Penjelasan",
    "regenerate": "Buat ulang",
    "regenerate_aria": "Buat ulang tafsir",
    "attribution": "Ringkasan dibuat AI · Bukan pengganti keilmuan yang berkualitas",
    "error": "Tidak bisa membuat tafsir.",
    "pending": "Membaca penjelasan…"
  },
  "related": {
    "heading": "Ayat Terkait",
    "copied": "Disalin: {{ref}}",
    "failedToCopy": "Gagal menyalin",
    "empty": "Tidak ada ayat terkait yang ditemukan.",
    "error": "Tidak bisa memuat ayat terkait.",
    "pending": "Mencari ayat terkait…"
  },
  "favorites": {
    "panel_aria": "Ayat favorit",
    "title": "Ayat Favorit",
    "proLocked": "Favorit ayat adalah fitur Pro.",
    "loading": "Memuat…",
    "failedToLoad": "Gagal memuat favorit",
    "empty": "Belum ada favorit. Ketuk hati pada ayat mana pun untuk menyimpannya.",
    "reference": "— Surah {{surah}}, Ayat {{ayah}}",
    "remove_aria": "Hapus dari favorit",
    "failedToRemove": "Gagal menghapus"
  }
}
